import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.global.useAcceptInvitationPageData', {
    alreadyAccepted: 'Invitation was already accepted',
    invitationNotFound: 'Can’t find the invitation for this account. Please try another account',
});
